interface WzBreakpoints {
  xs: BreakPointMedia;
  sm: BreakPointMedia;
  md: BreakPointMedia;
  xl: BreakPointMedia;
}

interface BreakPointMedia {
  down?: string;
  up: string;
}

export const wzBreakPoints: WzBreakpoints | any = {
  xs: {
    up: '(min-width: 0px)',
    down: '(max-width: 576px)',
  },
  sm: {
    up: '(min-width: 577px)',
    down: '(max-width: 992px)',
  },
  md: {
    up: '(min-width: 993px)',
    down: '(max-width: 1200px)',
  },
  xl: {
    up: '(min-width: 1201px)',
  },
};
